"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadSlice = void 0;

var tslib_1 = require("tslib");

var package_details_1 = require("@hopin-team/package-details");

var react_1 = tslib_1.__importStar(require("react"));

var loadWithWebpack_1 = require("./lib/loadWithWebpack");

var loadWithWindow_1 = require("./lib/loadWithWindow");

var useDynamicScript_1 = require("./lib/useDynamicScript");

exports.LoadSlice = (0, react_1.memo)(function (props) {
  var _a, _b, _c;

  var defaultSliceModule = 'Index'; //currently only exposing one remote as part of the webpack config

  if (!window.slices) {
    window.slices = {};
  }

  (0, react_1.useEffect)(function () {
    return function () {
      var _a; // If LoadSlice unmounts remove the initalised slice


      if ((_a = window === null || window === void 0 ? void 0 : window.slices) === null || _a === void 0 ? void 0 : _a[props.package]) {
        window.slices[props.package].initalised = false;
      }
    };
  });

  var _d = (0, react_1.useMemo)(function () {
    return (0, package_details_1.packageDetails)(props.package);
  }, [props.package]),
      name = _d.name,
      type = _d.type,
      version = _d.version,
      nameSnakeCase = _d.nameSnakeCase;

  var sliceUrl = (0, react_1.useMemo)(function () {
    var isSemver = /^\d+\.?\d+\.?\d+\.?/g;
    return "".concat(props.assetUrl, "/").concat(type, "/").concat(name, "/").concat(version, "/remoteEntry.js").concat(!isSemver.test(version) ? "?hash=".concat(Date.now()) : '');
  }, [name, props.assetUrl, type, version]);

  var Fallback = function Fallback() {
    return react_1.default.createElement(react_1.default.Fragment, null, props.loadingComponent);
  };

  var _e = (0, useDynamicScript_1.useDynamicScript)(sliceUrl),
      ready = _e.ready,
      failed = _e.failed;

  if (!ready) return react_1.default.createElement(Fallback, null);

  if (failed) {
    var error = "Loading slice ".concat(name, "@").concat(version, " failed. url: ").concat(sliceUrl);
    throw new Error(error);
  }

  var sliceFactory;

  switch (props === null || props === void 0 ? void 0 : props.loadUsing) {
    case 'window':
      {
        sliceFactory = (0, loadWithWindow_1.loadWithWindow)({
          scope: nameSnakeCase,
          module: defaultSliceModule,
          dependencies: props.dependencies,
          alreadyInitalised: (_b = (_a = window === null || window === void 0 ? void 0 : window.slices) === null || _a === void 0 ? void 0 : _a[props.package]) === null || _b === void 0 ? void 0 : _b.initalised,
          shareDependencies: props === null || props === void 0 ? void 0 : props.shareDependencies
        });
        window.slices[props.package] = {
          initalised: true
        };
        break;
      }

    case 'webpack':
    default:
      {
        sliceFactory = (0, loadWithWebpack_1.loadWithWebpack)(nameSnakeCase, defaultSliceModule);
      }
  }

  if (!sliceFactory) {
    var error = "Could not instantiate slice ".concat(name, "@").concat(version, " using method: ").concat((_c = props === null || props === void 0 ? void 0 : props.loadUsing) !== null && _c !== void 0 ? _c : 'default (aka webpack)');
    throw new Error(error);
  }

  var Slice = (0, react_1.lazy)(sliceFactory);
  return react_1.default.createElement(react_1.Suspense, {
    fallback: react_1.default.createElement(Fallback, null)
  }, react_1.default.createElement(Slice, tslib_1.__assign({}, props.UNSAFE_passProps, {
    assetUrl: props.assetUrl
  }), props.children));
});
exports.LoadSlice.displayName = 'LoadSlice';